import { render, staticRenderFns } from "./CmsRevisionSelectorPopup.vue?vue&type=template&id=ff896738&scoped=true&"
import script from "./CmsRevisionSelectorPopup.vue?vue&type=script&lang=js&"
export * from "./CmsRevisionSelectorPopup.vue?vue&type=script&lang=js&"
import style0 from "./CmsRevisionSelectorPopup.vue?vue&type=style&index=0&id=ff896738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff896738",
  null
  
)

export default component.exports